const costPivotStatus = state => state.status

const costPivotSummary = state => state.summary
const monthRange = state => [state.summary.minDate, state.summary.maxDate]
const minDate = state => state.summary.minDate
const maxDate = state => state.summary.maxDate
const selectedMonthRange = state => state.selectedMonthRange
const costPivotData = state => state.data
const costPivotFilterNames = state => state.filterNames
const costPivotFilterContent = state => state.filter
const costPivotSavedFilter = state => state.savedFilter
const costPivotUserTags = state => state.userTags
const costPivotDownloadLink = state => state.downloadLink
const costPivotDownloadStatus = state => state.downloadStatus
const costPivotDataToken = state => state.dataToken
const downloadMode = state => state.downloadMode
const costDownloadLink = state => state.costDownloadLink
const costDownloadStatus = state => state.costDownloadStatus
const costDownloadDataToken = state => state.costDownloadDataToken
export default {
    costPivotStatus,
    costPivotSummary,
    monthRange,
    minDate,
    maxDate,
    selectedMonthRange,
    costPivotData,
    costPivotFilterNames,
    costPivotFilterContent,
    costPivotSavedFilter,
    costPivotUserTags,
    costPivotDownloadLink,
    costPivotDownloadStatus,
    costPivotDataToken,
    downloadMode,
    costDownloadLink,
    costDownloadStatus,
    costDownloadDataToken
}
